module.exports = __webpack_public_path__ + "static/media/about-img.d1adb68a.jpg";